import { ChangeDetectorRef, Component, Inject, LOCALE_ID, OnInit } from "@angular/core";
import { Router } from "@angular/router";

import { AuthService } from "src/app/_app-core/services/auth/auth.service";
import { PosService } from "src/app/_services/posService";
import { PurchaseOrders } from "../../../_models/table-models";
declare var $: any;

import { formatDate } from "@angular/common";
import { AuthenticationService } from "src/app/_app-core/services/authenticationService";
import { DataExportService } from "src/app/_services/dataExportService";
import { PodService } from "src/app/_services/pod.service";

@Component({
  selector: "app-purchase-orders",
  templateUrl: "./purchase-orders.component.html",
  styleUrls: ["./purchase-orders.component.scss"],
})
export class PurchaseOrdersComponent implements OnInit {
  searchTerm: string = "";
  public isCollapsed = false;
  purchase_orders: PurchaseOrders[] = [];
  allPurchaseOrders: PurchaseOrders[] = [];
  responseData: any;
  poNo: any;
  isError: any;
  isEmpty = false;
  isSelected = false;
  displayName: any;
  page = 1;
  pageSize = 10;
  collectionSize: any;
  pos: any;
  filterKey: any;
  loading = true;
  sessionExpired = false;
  errorMsg = "";
  isCondensed: boolean = false;
  currentLayout = {
    isCondensed: true,
  };
  selectedOption = true;
  filterBy: any = "docNo";
  tableData: any;
  impersonate;
  poSelected = null;
  currentUserData: any;

  constructor(
    private router: Router,
    private authService: AuthService,
    private posService: PosService,
    private exportService: DataExportService,
    private cdref: ChangeDetectorRef,
    private authenticationService: AuthenticationService,
    private podService: PodService,
    @Inject(LOCALE_ID) public locale: string
  ) {}

  toggleSidebar() {
    this.currentLayout.isCondensed = !this.currentLayout.isCondensed;
    document.body.setAttribute("data-sidebar-size", this.currentLayout.isCondensed ? "condensed" : "default");
  }

  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }

  onSelectChanges(event) {
    this.isSelected = event.target.checked;
  }

  sendPo(po = null) {
    console.log(this.poSelected, "poSelected");
    localStorage.setItem("pods", JSON.stringify([this.poSelected]));
    localStorage.setItem("selectionType", "po");
    if (po !== null) {
      console.log(po + " this is the null value");
    } else {
      localStorage.setItem("poType", this.poSelected.po_ses_mat);
      this.router.navigate(["/upload-credit-note", this.poSelected.docNo]);
    }
  }

  ngOnInit(): void {
    console.log("purchase orders");
    this.displayName = localStorage.getItem("displayName");

    if (localStorage.getItem("impersonation") === null || localStorage.getItem("impersonation") === "") {
      this.impersonate = "false";
    } else {
      this.impersonate = localStorage.getItem("impersonation") || false;
    }

    //console.log(this.impersonate);
    this.fetchPurchaseOrders();
  }

  fetchPurchaseOrders() {
    this.loading = true;
    const userData = {
      supplierCode: localStorage.getItem("vendorCode"),
      docNo: this.filterBy === "docNo" ? this.searchTerm : undefined,
      // poNo: this.filterBy === "poNo" ? this.searchTerm : null,
      location: this.filterBy === "location" ? this.searchTerm : undefined,
      currCode: this.filterBy === "currCode" ? this.searchTerm : undefined,
      pageNo: this.page,
      pageSize: this.pageSize,
    };

    this.posService.fetchPurchaseOrderDetails(userData).subscribe(
      (res) => {
        console.log(res, "res");
        this.loading = false;
        this.responseData = res;

        if (this.responseData.code == 200) {
          this.purchase_orders = this.responseData.data.list;
          this.allPurchaseOrders = this.responseData.data.list;
          this.collectionSize = this.responseData.data.noOfRecords;
          // this.refreshPos();

          let sortedPos = this.purchase_orders.sort((a, b) => (a.creation_date > b.creation_date ? 1 : -1));
          const sellercode = localStorage.getItem("vendorCode");
          this.purchase_orders.forEach((po) => {
            po["inProcessInvoicedAmount"] = 0;
            po["canSubmitInvoice"] = sellercode == po["invoicingParty"]?.toString().trim() ? true : true;
            console.log(po["canSubmitInvoice"], "------------");
            po.location = po.barcodePrefix?.substring(2, 4);
          });
          this.pos = this.allPurchaseOrders;

          if (this.responseData.data.list.length === 0) {
            this.loading = false;
            this.isEmpty = true;
          } else {
            this.loading = false;
            this.isEmpty = false;
          }
        } else {
          this.loading = false;
        }
      },
      (error) => {
        console.log(error);
        this.loading = false;

        if (error.status === 401) {
          this.sessionExpired = true;
          this.errorMsg = error.error.msg;
        }
      }
    );
  }

  accountLogout() {
    const userData = {
      session: { sessionId: localStorage.getItem("eippSession") },
    };
    this.authService.logOut(userData).subscribe(
      (res) => {
        const responseData: any = res;
        if (responseData.status === "ok") {
          localStorage.clear();
          this.router.navigateByUrl("/");
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  refreshPos() {
    this.fetchPurchaseOrders();
  }

  onFilter(option: any) {
    this.filterBy = option.target.value;
    this.selectedOption = true;
  }

  onSearch(event: KeyboardEvent) {
    this.generalSearch(event);
  }

  generalSearch(event: KeyboardEvent) {
    console.log("generalSearch");

    this.searchTerm = (event.target as HTMLInputElement).value;
    this.page = 1;
    this.fetchPurchaseOrders();

    // if (this.searchTerm !== "") {
    //     this.pos = this.allPurchaseOrders.filter(
    //         (data) =>
    //             (data.docNo as string)
    //                 .toLowerCase()
    //                 .includes(this.searchTerm.toLowerCase()) ||
    //             (data.currCode as string)
    //                 .toLowerCase()
    //                 .includes(this.searchTerm.toLowerCase())
    //     );
    // } else {
    //     this.pos = this.purchase_orders;
    // }
  }

  trackPoNumber(index: number, po: any) {
    return this.pos ? this.pos : undefined;
  }

  exportToExcel() {
    const date = new Date();

    const fileName = (this.displayName = localStorage.getItem("vendorCode")) + "_Purchase_Order_Table_" + formatDate(date, "dd_MM_yyyy_h_mm_a", this.locale);

    if (this.selectedOption === false) {
      this.tableData = this.purchase_orders;
    } else {
      this.tableData = this.pos;
    }

    const cols = [
      {
        name: "PO No",
        colKey: "docNo",
      },
      {
        name: "PO Type",
        colKey: "po_ses_mat",
      },
      {
        name: "Location",
        colKey: "location",
      },
      {
        name: "PO Amount",
        colKey: "po_value",
      },
      {
        name: "Open PO Amount",
        colKey: "openPoValue",
      },
      {
        name: "Invoiced Amount",
        colKey: "invoicedAmount",
      },
      {
        name: "In-Process Invoice Amount",
        colKey: "inProcessInvoicedAmount",
      },
      {
        name: "PO Currency",
        colKey: "currCode",
      },
    ];

    this.exportService.exportToExcel(this.tableData, cols, fileName);
  }

  viewPoDetails(po: any) {
    this.podService.storePo(po);
    this.router.navigate(["/purchase-order-detail", po.docNo]);
  }

  submitPo(po: any) {
    console.log(po, "po");

    this.podService.storePo(po);
    this.router.navigate(["/proof-of-delivery", po._id]);
  }

  details() {
    console.log(Date.now(), "Date.now()");
  }
}
